'use client'

import { Box, Card, Chip, Grid, Stack, Typography } from '@mui/material'
import React from 'react'

import {
    mapMeasurementUnit,
    useGetCriteriaLabel,
    useGetCriteriaLevelColor,
    useTranslateMeasurements,
} from 'app/hooks/useAnalyzer'
import { AreaChart } from './AreaChart'

export const ChipCriteria = ({ measurements }) => {
    const { format } = useGetCriteriaLabel()
    const { format: formatColor } = useGetCriteriaLevelColor()
    const criteria = format(measurements)
    return (
        <Chip
            sx={{
                color: 'white',
                backgroundColor: formatColor(criteria.level),
            }}
            label={criteria.label}
        />
    )
}

export const CardMeasurement = ({ data }) => {
    const { format } = useTranslateMeasurements()
    const { format: formatUnit } = mapMeasurementUnit()
    return (
        <Box component={'section'}>
            <Grid container spacing={2}>
                {Object.entries(data).map(([key, value], i) => {
                    return (
                        <Grid item lg={3} key={`${key}-${value}`}>
                            <Card component={'div'}>
                                <Stack
                                    spacing={0.5}
                                    p={2}
                                    position={'relative'}
                                >
                                    <Typography variant="h5">
                                        {format(key)}
                                    </Typography>
                                    <Typography variant="caption">
                                        ผลการตรวจล่าสุด
                                    </Typography>

                                    <ChipCriteria
                                        measurements={
                                            value?.at(-1)?.measurements
                                        }
                                    />

                                    <Typography
                                        mt={1}
                                        variant="h5"
                                        component={'h2'}
                                    >
                                        {value
                                            ?.at(-1)
                                            ?.measurements?.map((v) => v.value)
                                            ?.join('/')}{' '}
                                        <Typography
                                            component={'span'}
                                            color={'#818181'}
                                            variant="h6"
                                        >
                                            {formatUnit(key)}
                                        </Typography>
                                    </Typography>
                                    <AreaChart data={value} name={key} />
                                </Stack>
                            </Card>
                        </Grid>
                    )
                })}
            </Grid>
        </Box>
    )
}
